<script>
import {updateMontant} from '../../../mixins/updateMontant.js';

export default {
  name: 'prestaLine',
  props:{
    ndpId: String,
    labelId: String,
    objet: String,
    montantHT: Number,
    date: String,
    frais: Array,
    nomPhase: String,
  },
  mixins:[
    updateMontant,
  ],
  data(){
    return {
      style:[],
    }
  },
  mounted(){
    
  },
  methods:{
    emitChange(evt, params){
      let isValid = true

      //Initialisation de l'objet à renvoyer au server. L'envoi au serveur se fera depuis le parent.
      let item = {
        _id: this.ndpId,
      }
      
      //J'annule l'affichage de l'erreur s'il y en avait une sur ce champ
      evt.target.classList.remove("phaseLine__error");

      //Je complète l'objet à renvoyer
      switch (params){
        case 'objet':
          item.objet = evt.target.value
          break;
        case 'montantHT':
          if (!this.updateMontant(evt.target.value)){
            isValid = false
            evt.target.classList.add("phaseLine__error");
          } else {
            item.montantHT = this.updateMontant(evt.target.value).num
            evt.target.value = this.updateMontant(item.montantHT).str
          }
          break;
        case 'typeFrais':
          item.labelId = this.labelId
          break;
        case 'date':
          item.date = evt.target.value
          break;
      }
      
      if (isValid){
        this.$emit('update', item)
      }
    }
  }
}
</script>


<template>
  <div class="phaseLine">
    <span class="phaseLine__name"> {{nomPhase}} </span>
    <input type="date" class="phaseLine__date" :value="date.slice(0, 10)" @change="emitChange($event, 'date')" />
    <select v-model="labelId" @change="emitChange($event, 'typeFrais')" class="phaseLine__select">
      <option v-for="item in frais" :key="item._id" :value="item._id" > {{item.name}} </option>
    </select>
    <input type="text" placeholder="Objet" :value="objet" class="phaseLine__objet" @change="emitChange($event, 'objet')"/>
    <input type="text" :value="updateMontant(montantHT, 2).str" class="phaseLine__montant" @change="emitChange($event, 'montantHT')"/><span class="phaseLine__text phaseLine__unit">€<sup>HT</sup></span>
    <span class="material-icons phaseLine__icon" @click="$emit('suppr', ndpId)">delete_outline</span>
  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../assets/main.scss';

.phaseLine{
  display: flex;
  @include myBlock;
  padding: 7px 10px;
  align-items: center;
  margin: 0 0 4px 0;

  &__text{
    @include myFont;
    font-size: 13px;
    color: $black-bolder;
  }

  &__name{
    width: 150px;
    @include myFont;
    font-size: 13px;
    color: $black-bolder;
    @include monoline;
  }

  &__date{
    border: none;
    width: 200px;
    margin: 2px 5px 0 0;
  }

  &__select{
    border: none;
    width: 130px;
  }

  &__objet{
    @include myField;
    color: $black-bolder;
    flex: 1;
    margin: 0 20px;
    width: 130px;
    font-size: 13px;
  }

  &__montant {
    @include myField;
    color: $black-bolder;
    width: 55px;
    text-align: right;
    font-size: 13px;
    // padding-right: 28px;
  }

  &__unit{
    margin: 0px 5px 3px 5px;
  }

  &__total{
    @include myFont;
    font-size: 13px;
    color: $black-bolder;
    text-align: right;
    padding: 2px 0 0 0;
  }

  &__icon{
    color: $mainBlack;
    font-size: 20px;
    margin: 0 0 0 10px;

    &:hover{
      cursor: pointer;
      color: $color2;
    }
  }

  &__error{
    color: $alert !important;
    background-color: $alert-lighter;
  }
}

</style>
